<template>
  <div class="park">
    <!-- 面包屑 -->
    <public-bread-crumb :routes="routes" />
    <!-- 顶部工具栏 -->
    <public-top-bar
      placeholder="请输入园区名称"
      :topBarBtns="topBarBtns"
      :onTableSearchFun="onTableSearchFun"
      @changeBasicSearchFun="changeBasicSearchFun"
    />
    <!-- 页面Table -->
    <public-table
      :columns="columns"
      :tableData="tableData"
      :tableInfo="tableInfo"
      :operateA="operateA"
      :operateWidth="operateWidth"
      :tableLoading="tableLoading"
      @selectTableRowFun="selectTableRowFun"
    />
    <!-- 删除弹窗 -->
    <public-del
      ref="delWeight"
      delDesc="该园区及园区下的入驻单位数据将被删除，且不可恢复，是否确定？"
      :btnLoading="btnLoading"
      :delTableDataFun="delTableDataFun"
    />
    <!-- 支付接入弹窗 -->
    <a-modal
      v-model="isShowPay"
      title="支付接入"
      width="342px"
      class="park-pay"
    >
      <div>
        <div style="margin-bottom: 24px">
          <p style="margin-bottom: 0">微信支付商户号：</p>
          <a-input
            placeholder="请填写微信支付商户号"
            v-model.trim="wxPayCode"
          />
          <p
            style="margin-bottom: 0"
            v-if="wxErrMsg"
            class="check-txt"
            :class="{ ok: wxErrMsg === checkdMsgs[1] }"
          >
            {{ wxErrMsg }}
          </p>
        </div>
        <div :class="{ inputErr: apiErrMsg }">
          <p style="margin-bottom: 0">API密钥：</p>
          <a-input placeholder="请填写API密钥" v-model.trim="apiPwdCode" />
          <p style="margin-bottom: 0" v-if="apiErrMsg" class="check-txt">
            {{ apiErrMsg }}
          </p>
        </div>
      </div>
      <template slot="footer">
        <a-button
          v-if="!isCheckd"
          type="primary"
          class="footer-btn"
          :loading="btnLoading"
          @click="searchPayCode"
          >验证</a-button
        >
        <a-button
          v-if="isCheckd"
          type="primary"
          class="footer-btn"
          :loading="btnLoading"
          @click="setPayCode"
          >确定</a-button
        >
        <a-button
          @click="isShowPay = false"
          class="footer-btn"
          style="margin-right: 0; background: #ecedff"
          >取消</a-button
        >
      </template>
    </a-modal>
  </div>
</template>

<script>
import { publicTableList } from "@/mixins/mixinsData";
import ParkServices from "@/services/park.services";
export default {
  name: "Park",
  mixins: [publicTableList],
  data() {
    return {
      // 支付弹窗显隐
      isShowPay: false,
      // 微信支付商户号
      wxPayCode: "",
      // API密钥
      apiPwdCode: "",
      // 微信支付商户号验证提示
      wxErrMsg: "",
      // API密钥验证提示
      apiErrMsg: "",
      // 设置支付的园区id
      parkId: "",
      // 切换'验证按钮'和'确定按钮'
      isCheckd: false,
      // 接口验证结果提示
      checkdMsgs: ["商户号错误", "商户号可用", "商户号被占用"],
      routes: [
        {
          name: "园区管理",
          path: "/park",
        },
      ],
      topBarBtns: [
        {
          name: "新增",
          type: "primary",
          fun: this.addPageOrEditPage,
        },
        {
          name: "删除",
          type: "",
          fun: this.topBarDelBtnFun,
        },
        {
          name: "全选",
          type: "",
          fun: this.selectAllFun,
        },
      ],
      columns: [
        {
          title: "园区名称",
          dataIndex: "name",
          type: "tooltip",
          width: 271,
        },
        {
          title: "园区系统管理员",
          dataIndex: "manageName",
          type: "tooltip",
          width: 262,
        },
        {
          title: "园区系统管理员账号",
          dataIndex: "managePhone",
          width: 254,
        },
        {
          title: "园区运维账号",
          dataIndex: "opsAccountName",
        },
      ],
      operateA: [
        {
          name: "编辑",
          fun: this.addPageOrEditPage,
        },
        {
          name: "删除",
          fun: this.rowDel,
        },
        {
          name: "支付接入",
          fun: this.openPayWeight,
        },
      ],
      operateWidth: 240,
    };
  },
  watch: {
    isShowPay() {
      if (!this.isShowPay) {
        this.wxPayCode = "";
        this.apiPwdCode = "";
        this.wxErrMsg = "";
        this.apiErrMsg = "";
        this.parkId = "";
        this.isCheckd = false;
      }
    },
    wxPayCode() {
      if (this.wxPayCode) {
        this.wxErrMsg = "";
      }
    },
    apiPwdCode() {
      if (this.apiPwdCode) {
        this.apiErrMsg = "";
      }
    },
  },
  mounted() {},
  // 缓存组件激活
  activated() {
    // 获取园区列表
    this.getTableData(ParkServices.GetParkTable);
    // 获得删除接口
    this.tableServices.delServices = ParkServices.Delete;
  },
  // 缓存组件停用
  deactivated() {},
  methods: {
    // 打开支付接入弹窗
    async openPayWeight(item) {
      this.parkId = item.id;
      let res = await ParkServices.GetParkPayData({ id: item.id });
      if (res.status === 0) {
        this.wxPayCode = res.result.merchant;
        this.apiPwdCode = res.result.merchantSecret;
      }
      this.isShowPay = true;
    },

    // 验证支付商户号
    async searchPayCode() {
      if (!this.wxPayCode && !this.apiPwdCode) {
        this.wxErrMsg = "请填写微信支付商户号";
        this.apiErrMsg = "请填写API密钥";
      } else if (!this.wxPayCode) {
        this.wxErrMsg = "请填写微信支付商户号";
      } else if (!this.apiPwdCode) {
        this.apiErrMsg = "请填写API密钥";
      } else {
        this.btnLoading = true;
        let res = await ParkServices.CheckWxPayCode({
          areaId: this.parkId,
          mchId: this.wxPayCode,
          mchKey: this.apiPwdCode,
        });
        this.btnLoading = false;
        if (res.status === 0) {
          this.wxErrMsg = this.checkdMsgs[res.result];
          this.isCheckd = res.result === 1;
        }
      }
    },

    // 设定支付接入
    async setPayCode() {
      if (this.isCheckd) {
        this.btnLoading = true;
        let res = await ParkServices.SetParkPay({
          id: this.parkId,
          merchant: this.wxPayCode,
          merchantSecret: this.apiPwdCode,
        });
        res.status === 0 && this.notification("success", "成功", res.result);
        this.btnLoading = false;
        this.isShowPay = false;
        this.getTableData(ParkServices.GetParkTable);
      }
    },

    // 编辑?新增?
    addPageOrEditPage(item) {
      if (item && item.id) {
        this.$router.push(`/park/modify-form?id=${item.id}`);
      } else {
        this.$router.push("/park/modify-form");
      }
    },
  },
};
</script>

<style lang="less">
.park-pay {
  // height: 310px;
  .ant-modal-content {
    .ant-modal-header {
      height: 53px;
      padding: 16px 0;
      text-align: center;
      .ant-modal-title {
        font-size: 16px !important;
        color: #333333 !important;
      }
    }
    .ant-modal-footer {
      height: 64px;
      padding: 16px;
      text-align: center;
    }
    .footer-btn {
      width: 88px;
      height: 32px;
      margin-right: 32px;
      border-radius: 3px;
      border: 0px;
    }
  }
  .check-txt {
    font-size: 14px;
    color: #f5222d;
  }
  .ok {
    color: #00cc33 !important;
  }
  .inputErr {
    input {
      border: 1px solid red !important;
    }
    :focus {
      border: 1px solid red !important;
      box-shadow: none !important;
    }
  }
}
// .inputErr {
//     input {
//       border: 1px solid red !important;
//     }
//     :focus {
//       border: 1px solid red !important;
//       box-shadow: none !important;
//     }
//   }
</style>
